<template>
  <div class="container" :key="'entity-list'">
    <div class="entity-list flex-col mar-top-50">
      <div class="flex-row-align-center mar-bottom-50">
        <PageHeading
          :title="'Entities'"
          :description="'All objects that contain a location and time component'"
          :tooltip="'Entities are any moving or stationary component in your business with a location & time dimension. They are used to define the relationships between data sources.'"
        />
        <div class="flex-expand"></div>
        <router-link to="/new-entity">
          <button class="button fs-small flex-center glow-shadow">
            <i class="material-icons md-18 mar-right-10">add</i>
            <b>CREATE</b>
          </button>
        </router-link>
      </div>
      <div
        v-if="isLoading && !(getEntities && getEntities.length > 0)"
        class="flex-center pad-50"
      >
        <LoadingBar />
      </div>
      <div v-if="getEntities && getEntities.length > 0" class="contents">
        <router-link
          v-for="entity in getEntities"
          :key="entity.id"
          class="grid-item smooth-shadow"
          :to="`/entities/${entity.id}`"
        >
          <div class="details-area">
            <i class="material-icons entity-icon">device_hub</i>
            <p class="title">{{ entity.name }}</p>
            <p class="caption">{{ entity.description }}</p>
            <p class="created-by">
              Created by
              <span class="fc-accent">{{ entity.created_by }}</span>
            </p>
          </div>
        </router-link>
      </div>
      <NotFound
        v-else-if="!isLoading && !getEntities"
        :message="'No entities found! Click on create to add a new entity'"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { startTour } from "@/components/entities/tours/EntityList.tour";

export default {
  components: {},
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters("Entities", ["getEntities"]),
  },
  methods: {
    ...mapActions("Entities", ["fetchEntities"]),
  },
  watch: {
    getEntities(value) {},
  },
  mounted() {
    if (this.getEntities.length === 0) {
      this.isLoading = true;

      this.fetchEntities()
        .then((response) => {
          this.isLoading = false;
          startTour();
        })
        .catch((error) => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
      startTour();
    }
  },
};
</script>

<style lang="scss">
.entity-list {
  margin-bottom: 50px;
  min-height: 300px;
  .contents {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 15px;

    @include respond-below(md) {
      grid-template-columns: 1fr;
    }

    .grid-item {
      background: var(--color-secondary);
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      padding: 10px 0px;
      color: var(--font-color);
      transition: 0.3s all ease-in-out;
      min-width: 100%;

      &:hover {
        cursor: pointer;
        transform: scale(1.02);
      }

      .card-icon {
        padding: 10px;
        background: var(--border-color);
        margin: 0 15px 0 0;
        border-radius: 50%;

        &.placeholder {
          width: 25px;
          height: 25px;
        }
      }

      .details-area {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 20px;
      }

      .entity-icon {
        font-size: 3em;
        padding: 15px;
        color: var(--color-primary);
        background: var(--color-primary-light);
        border-radius: 50%;
        margin-bottom: 15px;
      }

      p {
        margin: 0;

        &.title {
          font-weight: bold;
          font-size: 1.2em;

          &.placeholder {
            width: 120px;
            background: var(--font-color-unselected);
            border-radius: 10px;
            padding: 5px;
          }
        }

        &.caption {
          opacity: 0.6;
          display: -webkit-box;
          flex: 2;
          min-height: 45px;
          padding-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-align: center;

          &.placeholder {
            width: 100px;
            background: var(--font-color-unselected);
            border-radius: 10px;
            padding: 5px;
            margin-top: 10px;
          }
        }

        &.created-by {
          padding: 10px 0 0 0;
        }
      }
    }
  }
}
</style>
